export default __webpack_public_path__ + "static/media/sin2.0448906a.webp";